import React from "react";
import AddButton from "../AddButton/AddButton";
import DateHelper from "../DateHelper/DateHelper";

export default class EmailCampaignPresenterEmails extends React.Component{
  constructor(props) {
    super(props);
    this.renderEmailSelectBoxes = this.renderEmailSelectBoxes.bind(this)
  };

  render() {
    return (
      <div>
        {/* {this.renderAddButton()} */}
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" style={{ marginBottom: 0 }}>
              <div className="panel-heading">
                <h3 className="panel-title pull-left">
                  {I18n.t('email_details')}
                </h3>
                <div className="pull-right">
                  <AddButton
                    key={this.props.email_campaign_id}
                    model="Email"
                    disabled={true}
                    text={I18n.t('add')}
                    new_button={false}
                    ids={Object.keys(this.props.emailFields).length > 0 ? Object.keys(this.props.emailFields).map((email) => { return email; }) : null}
                    buttonClasses="btn btn-dark"
                  />
                </div>
                <div className="clearfix"></div>
              </div>
              {this.renderEmailSelectBoxes()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderEmailSelectBoxes() {
    var emailSelectBoxes = this.props.emailSelectBoxes.map((select, idx) => {
      return (
        <div key={idx} className="col-md-12">
          <div className="col-md-2">
            <label style={{ marginTop: '15px' }}>{`${I18n.t('emails')}`}</label>
            <div className="form-group">
              <p>{select.value}</p>
            </div>
          </div>
          {this.renderEmailTrigger(select.value, select.id)}
        </div>
      )
    });

    return emailSelectBoxes
  }

  renderEmailTriggerOptions(trigger, value) {
    if(trigger == I18n.t("specific_date")) {
      return (
        <div>
          <div className="col-md-2">
            <label style={{ marginTop: '15px' }}>{`${I18n.t('select_date')}*`}</label>
            <div className="form-group">
              <p>{DateHelper.printDateToScreen(DateHelper.parseDateFromBackend(this.props.emailFields[value].date), this.props.date_format)}</p>
            </div>
          </div>
          <div className="col-md-4">
            <label style={{ marginTop: '15px' }}>{I18n.t('select_time')}</label>
            <p>{this.props.emailFields[value].time ? this.props.emailFields[value].time : ''}</p>
          </div>
        </div>
      )
    }
  }

  renderEmailTrigger(value, id) {
    var emailFields = this.props.emailFields

    return (
      <div>
        <div className="col-md-2">
          <label style={{ marginTop: '15px' }}>{`${I18n.t('column')} ${I18n.t('trigger')}*`}</label>
          <div className="form-group">
            <p>{emailFields[value].trigger}</p>
          </div>
        </div>
        {this.renderEmailTriggerOptions(emailFields[value].trigger, value, id)}
      </div>
    )
  }
};
